
export const assessmentTypes = [
  {
    id: 1,
    name: "ELI Assessment",
    code: "ELI_ASSESSMENT",
    masterTemplate:{}
  },
  {
    id: 2,
    name: "Self Assessment",
    code: "SELF_ASSESSMENT"
  },
  {
    id: 3,
    name: "Common",
    code: "COMMON"
  }
];

